<template>
  <div class="login">
    <el-row style="margin-top: 40px;">
      <el-col
        class="hidden-xs-only"
        :sm="3"
        :md="6"
        :lg="8"
        :xl="9"
      >
        &nbsp;
      </el-col>
      <el-col
        :xs="24"
        :sm="18"
        :md="12"
        :lg="8"
        :xl="6"
      >
        <transition name="el-fade-in">
          <el-card v-show="show">
            <div
              slot="header"
              class="clearfix"
            >
              <span>Új jelszó</span>
              <el-button
                style="float: right; margin-top: -5px;"
                type="primary"
                size="small"
                v-if="hasError"
                @click="$router.push('/login')"
                plain
              >
                Jelszóemlékeztető igénylése
              </el-button>
            </div>
            <el-form
              :model="resetPassword"
              @submit.prevent.native="reset"
              :rules="resetRules"
              status-icon
              hide-required-asterisk
            >
              <el-form-item
                label="Felhasználónév"
                prop="username"
              >
                <el-input
                  v-model="resetPassword.username"
                  @keyup.enter.native="reset"
                />
              </el-form-item>
              <el-form-item
                label="Új jelszó"
                prop="password"
              >
                <el-input
                  v-model="resetPassword.password"
                  type="password"
                  show-password
                  @keyup.enter.native="reset"
                />
              </el-form-item>
              <el-form-item
                label="Új jelszó megerősítése"
                prop="password"
              >
                <el-input
                  v-model="resetPassword.password_confirmation"
                  type="password"
                  show-password
                  @keyup.enter.native="reset"
                />
              </el-form-item>
            </el-form>
            <div style="margin-top: 20px;">
              <el-button
                :loading="loading"
                @click="reset"
                type="primary"
                style="width: 100%;"
              >
                Jelszó lecserélése
              </el-button>
            </div>
          </el-card>
        </transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      loading: false,
      hasError: false,
      resetRules: {
        email: {
          required: true,
          message: 'E-mail megadása kötelező',
          trigger: 'change',
        },
      },
      resetPassword: {
        email: '',
      },
    };
  },
  mounted() {
    setTimeout(() => this.show = true, 200);
  },
  methods: {
    openResetPassword() {
      this.page = null;
      setTimeout(() => this.page = 'reset-password', 300);
    },
    async reset() {
      this.loading = true;
      try {
        await axios.post('api/reset/password', {
          token: this.$route.params.token,
          username: this.resetPassword.username,
          password: this.resetPassword.password,
          password_confirmation: this.resetPassword.password_confirmation
        });
        this.$router.push('/login');
      } catch (e) {
        this.handleServerErrors(e);
        this.hasError = true;
      } finally {
        this.loading = false;
      }
    },
    handleServerErrors(e) {
      const validationErrors = e.data.errors;
      const resetPasswordError = e.data.error;
      if (validationErrors) {
        return;
      }
      switch (resetPasswordError) {
        case 'invalid_email':
          return this.$messageWrapper.error('Hibásan megadott e-mail cím');
        case 'invalid_token':
          return this.$messageWrapper.error('Lejárt token. Kérj új jelszóemlékeztetőt');
        case 'invalid_password':
          return this.$messageWrapper.error('Nem megfelelő jelszó. Legalább 8 karakter hosszúnak kell lennie');
        default:
          return this.$messageWrapper.error('Hiba történt');
      }
    }
  },
};
</script>

<style scoped>
  .login {
    position: fixed;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #2b5876;
    background: -webkit-linear-gradient(to right, #4e4376, #2b5876);
    background: linear-gradient(to right, #4e4376, #2b5876);
  }
</style>
